{
  "loan-estimate-table-title": "Presupuesto del Préstamo",
  "final": "Final",
  "did-this-change": "¿Esto cambió?",
  "total-closing-costs": "Costo de Cierre Total (J)",
  "paid-before-closing": "Pagado Antes del Cierre",
  "closing-costs-financed": "Costos de Cierre Financiados",
  "down-payment-from-borrower": "Pago Inicial del Prestatario",
  "deposit": "Depósito",
  "funds-for-borrower": "Fondos para el Prestatario",
  "seller-credits": "Créditos del Vendedor",
  "adjustments-other-credits": "Ajustes / Otros Créditos",
  "cash-to-close": "Efectivo para cerrar",
  "yes-option": "Sí",
  "no-option": "No"
}
